import type { Game } from '@adgf/shared';

export interface GameEngineConfig {
  width: number;
  height: number;
  parent?: string | HTMLElement;
  backgroundColor?: string;
  scaleMode?: 'FIT' | 'RESIZE' | 'NONE';
  pixelArt?: boolean;
}

export interface LoadedGame {
  game: Game;
  version: string;
  config: GameEngineConfig;
  sourceUrl: string;
}

export interface GameEngineEvents {
  onGameStart?: (gameId: string) => void;
  onGameOver?: (gameId: string, score?: number) => void;
  onLevelComplete?: (gameId: string, level: number) => void;
  onError?: (gameId: string, error: Error) => void;
}

export const DEFAULT_ENGINE_CONFIG: GameEngineConfig = {
  width: 800,
  height: 600,
  backgroundColor: '#1a1a2e',
  scaleMode: 'FIT',
  pixelArt: false,
};
